import styled from 'react-emotion'
import { themeGet as th } from 'styled-system'

import Mailbox from './Mailbox'

export default styled(Mailbox)`
  &&& {
    .email {
      color: ${th('colors.gray')};
      font-size: ${th('fontSizes.1')}px;
      font-weight: ${th('fontWeights.regular')} !important; /* SUI override */
      margin-left: ${th('space.1')}px;
    }
  }
`
